import { FAIL, PASS } from '../../filterQueryFormat/MatchStatus';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import MatchStatusIconCircle from '../operator/MatchStatusIconCircle';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const SinglePanelMatchStatusIcon = props => {
  const {
    matchStatus
  } = props;
  if (matchStatus === FAIL) {
    return /*#__PURE__*/_jsx(MatchStatusIconCircle, {
      matchData: {
        IconComponent: RemoveIcon,
        iconColor: 'icon-alert-default',
        size: '100'
      }
    });
  } else if (matchStatus === PASS) {
    return /*#__PURE__*/_jsx(IconHolder, {
      icon: SuccessIcon,
      color: "fill-positive-default",
      size: "400",
      padding: "0"
    });
  } else {
    return null;
  }
};
export default SinglePanelMatchStatusIcon;